export default "__VITE_ASSET__DaR5zSV$__"